import React, { useRef, useState, useEffect } from 'react';
import IframeResizer from 'iframe-resizer-react';
import { useSelector } from 'react-redux';
import { getUserProfile } from '@store/common/selectors';
import http from '@api/common';
import { createdSignedEmbedUrl } from './util';
// eslint-disable-next-line react/display-name
export default (props: any) => {
  const profile = useSelector(getUserProfile);
  const {
    match: {
      params: { id },
    },
  } = props;
  const iframeRef = useRef(null);
  const [lookConfig, setLookerConfig] = useState([]);
  const [link, setLink] = useState<string | null>(null);

  const NBCCustomers = [1960180534, 1960182777, 1960184661];
  const DemoCustomers = [1960185023];

  const getEmbedUrlForDemoReportId = (reportId: string) => {
    switch (reportId) {
      case 'audience':
        return 'embed/dashboards/advertising_insights_demo_data::audience';
      case 'campaigns':
        return 'embed/dashboards/advertising_insights_demo_data::campaigns';
      case 'demographics':
        return 'embed/dashboards/advertising_insights_demo_data::demographics';
      case 'content':
        return 'embed/dashboards/advertising_insights_demo_data::content';
      case 'workbench':
        return 'embed/explore/advertising_insights_demo_data/convivaJoinExperian';
      default:
        return null;
    }
  };

  const getEmbedUrlForNBCReportId = (reportId: string) => {
    switch (reportId) {
      case 'audience':
        return 'embed/dashboards/audience-insights-pg-report::audience_overview';
      case 'campaigns':
        return 'embed/dashboards/audience-insights-pg-report::campaign_dashboard';
      case 'device':
        return 'embed/dashboards/audience-insights-pg-report::device_dashboard';
      case 'dma':
        return 'embed/dashboards/audience-insights-pg-report::dma_dashboard';
      case 'households':
        return 'embed/dashboards/audience-insights-pg-report::households_dashboard';
      case 'workbench':
        return 'embed/explore/audience-insights-pg-report/convivaJoinExperian';
      default:
        return null;
    }
  };

  useEffect(() => {
    http.get('/advertising-insights-looker/config', {}).then((resp) => {
      setLookerConfig(resp.data);
    });
  }, []);

  useEffect(() => {
    if (lookConfig.length > 0 && profile) {
      const { customer_id: customerId } = profile;
      let currentDashboardId;
      if (DemoCustomers.includes(customerId)) {
        currentDashboardId = getEmbedUrlForDemoReportId(id);
      } else if (NBCCustomers.includes(customerId)) {
        currentDashboardId = getEmbedUrlForNBCReportId(id);
      }

      const lookerConfig: any = lookConfig[0] || {};
      const urlData: any = {
        host: lookerConfig.embedHost, // 'looker-dev1.content.conviva.com',
        secret: lookerConfig.embedSecret, // process.env.LOOKER_EMBED_SECRET,
        externalUserId:
          lookerConfig.embedGroupExternalId === ''
            ? `${customerId}-${lookerConfig.embedUserGroupIds}`
            : lookerConfig.embedGroupExternalId,
        permissions: lookerConfig.embedPermissions.split(','),
        models: lookerConfig.embedModels.split(','),
        accessFilters: {},
        sessionLength: Number(lookerConfig.embedSessionTimeoutSec),
        embedUrl: currentDashboardId, // '/embed/dashboards/343', //'/embed/dashboards/api_access_logs::api_usage_dashboard', //'/embed/dashboards/338',
        forceLogoutLogin: true,
        firstName: lookerConfig.embedUserFirstName,
        lastName: '',
        groupIds: lookerConfig.embedUserGroupIds
          ? lookerConfig.embedUserGroupIds.split(',').map((val) => Number(val))
          : [],
        // userAttributes: {
        //  ei_daily_quota: 10000,
        //  allowed_customers: '1960184521',
        // },
      };
      const finalUmbedUrl = createdSignedEmbedUrl(urlData);
      setLink(finalUmbedUrl);
    }
  }, [id, lookConfig, profile]);

  if (link) {
    return (
      <>
        <IframeResizer
          forwardRef={iframeRef}
          heightCalculationMethod="lowestElement"
          inPageLinks
          log
          src={link}
          style={{ width: '1px', minWidth: '100%', height: '100%' }}
        />
      </>
    );
  }
  return null;
};
